import React from "react";
import Link from "@qlik/qlik/src/components/Link";
import { createParameterizedUrl } from "@qlik/qlik/src/lib/util/helpers";
import { useLocation } from "@reach/router";

const LinkWithIcon = ({ data }) => {
    const { title, icon, pageLink, browsingContext } = data ?? {};
    const iconUrl = icon?.[0]?.secure_url?.replace("/f_auto", "").replace("/q_auto", "");
    const location = useLocation();

    let pageUrl = createParameterizedUrl(data);
    const linkProps = {
        to: pageUrl,
        newWindow: browsingContext === "New Tab",
        className: "z-1 group/link relative flex items-center gap-5",
    };

    return (
        <div>
            <Link {...linkProps}>
                <span className="-z-1 absolute -inset-2.5 rounded bg-white shadow-xlSmall opacity-0 transition-opacity transition-300 xl:group-hover/link:opacity-100" />
                {iconUrl && (
                    <div className="flex items-center w-10 h-10">
                        <picture>
                            <source media="(max-width:768px)" />
                            <img
                                loading="lazy"
                                src={iconUrl}
                                alt={title}
                                className="w-auto h-auto max-w-full max-h-full"
                            />
                        </picture>
                    </div>
                )}
                {title && (
                    <p className="text-base font-bold tracking-normal lg:text-md xl:group-hover/link:text-green">
                        {title}
                    </p>
                )}
            </Link>
        </div>
    );
};
export default LinkWithIcon;
